module.exports = __webpack_public_path__ + "img/skull-head.ef5899b6.svg";